const EMAIL_DOMAIN = process.env.REACT_APP_EMAIL_PARSE_DOMAIN;

export const getOrganizationEmail = (organizationId: string) => `o-${organizationId}@${EMAIL_DOMAIN}`;

export const getBorrowerEmail = (borrowerId: string) => `b-${borrowerId}@${EMAIL_DOMAIN}`;
